module.exports = function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="user-wrap">\n    ';
 if (data.letter) { ;
__p += '\n    <div class="profile-photo" style="background-color: ' +
((__t = ( data.background )) == null ? '' : __t) +
'">' +
((__t = ( data.letter )) == null ? '' : __t) +
'</div>\n    ';
 } ;
__p += '\n    <div class="user-info">\n        <div class="name">\n            <div class="display-name">' +
__e( data.first_name ) +
' ' +
__e( data.last_name ) +
'</div>\n            ';
 if (data.job_title) { ;
__p += '\n            <div class="title">' +
__e( data.job_title ) +
'</div>\n            ';
 } ;
__p += '\n        </div>\n        <div class="labels">\n            ';
 if (data.you === true) { ;
__p += '\n            <div class="label">You</div>\n            ';
 } ;
__p += '\n\n            ';
 if (data.admin === true) { ;
__p += '\n            <div class="label">Admin</div>\n            ';
 } ;
__p += '\n\n            ';
 if (data.superuser === true) { ;
__p += '\n            <div class="label">Superuser</div>\n            ';
 } ;
__p += '\n\n            ';
 if (data.worldpay_rm === true) { ;
__p += '\n            <div class="label">Worldpay RM</div>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n</div>';
return __p
}